import React, { useState, useEffect, useRef } from 'react'
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Grid,
  Box,
  Typography,
  Container,
  Divider
} from '@mui/material/'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { processLogin } from '@pages/LoginPage'
import { useDispatch } from 'react-redux'
import useAlert from '@hooks/useAlert'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import ReactDOM from 'react-dom'
import { QRCodeSVG } from 'qrcode.react'
import {uuidv4} from '@util/helper'
import WebService from '@util/webService'
import { setAccount } from '@redux/actions/accountAction'
import { isExpired, decodeToken } from "react-jwt";
import HourglassBottomOutlined from '@mui/icons-material/HourglassBottomOutlined';
import { afterLogin } from '@pages/LoginPage'
const totSec = 2 * 60
const QrLogin = ({ dialogHandler }) => {
  const [qrcode, set_qrcode] = useState('')
  const dispatch = useDispatch()
  const {alert, renderAlert} = useAlert()
  const navigate = useNavigate()
  const handleClose = () => {
    dialogHandler[1](false)
  }
  const [timer, _set_timer] = useState({min:parseInt(totSec / 60), sec: totSec % 60})
  const secRef = useRef(totSec)
  const intervalRef = useRef(null)


  const set_timer = () => {
    const min = parseInt(secRef.current / 60)
    const sec = secRef.current % 60
    _set_timer({min:min, sec:sec})
  }

  useEffect(() => {
    
    intervalRef.current = setInterval(()=> {
      if(secRef.current >= 1) {
        secRef.current = secRef.current - 1
        set_timer()
      }
      else {
        set_qrcode('')
      }
    }, 1000)

  }, [dialogHandler[0]])

  

  const evtSourceRef = useRef(null)

  const handleLogin = async (event) => {
    // const loginInfo = JSON.parse(e.data);
      const resp = JSON.parse(event.data)
      if(resp.repCode !== 'ack') {
        alert(resp.repMessage, () => {handleClose()})
        return
      }
      await afterLogin(resp, dispatch)

      alert('로그인 되었습니다.', () => {
        handleClose()
        navigate('/')
      })
  }

  const subscribeUuid = async() => {
    const uuid = uuidv4()
    const code = `schoolmanager://${uuid}` 
    

    // axios 로 콜하는 것이 아니므로 url 에 /scm/api 붙는 것에 주의
    const url = `/scm/api/public/subscribe/qr/${uuid}`
    evtSourceRef.current = new EventSource(url)

    evtSourceRef.current.addEventListener('login', handleLogin)
    set_qrcode(code)
    
  }

  useEffect(() => {
    subscribeUuid()
  }, [dialogHandler[0]])

  useEffect(() => {
    return () => {
      if(evtSourceRef.current) {
        evtSourceRef.current.removeEventListener('login', handleLogin)
        evtSourceRef.current.close()
        evtSourceRef.current = null
      }
      if(intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
    }
  },[])

  return (
    <>
      {renderAlert()}
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" align="center">
            QR 코드 로그인
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} style={{}}> 
              <div style={{display:'flex', justifyContent:'center', alignItems:'center',border:'1px solid #fafafa', width:'100%', height:'100%'}}>
                {
              qrcode !== '' ? (
                <QRCodeSVG value={qrcode}/>
              ) : (
                <>
                  <HourglassBottomOutlined />
                  <Typography style={{fontWeight:'bold'}}>시간이 초과되었습니다.</Typography>
                </>
                
              )
            }
              </div>
            
            </Grid>
            <Grid item xs={12} sm={6} > 
              <Typography style={{textAlign:'center', fontWeight:'bold'}}>남은시간: {timer.min} 분 {timer.sec}초</Typography>
              <Typography style={{textAlign:'center', fontWeight:'bold', margin:10}}>[로그인 방법]</Typography>
              <Typography variant='body2'>스쿨매니저 모바일앱 로그인 후 우측 상단 이름 옆 아이콘 <span style={{fontWeight: 'bold' }}>[--]</span> 터치하여 QR 코드를 시간 내에 스캔 </Typography>
            </Grid>
          </Grid>
          
          
        </DialogContent>
        <DialogActions>
          <Divider />
          <div style={{display:'flex', flex:1, flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
            <Button onClick={handleClose} style={{margin:5}}>닫기</Button>
          </div>
        </DialogActions>
      </Dialog>
      
    </>
  )
}

export default QrLogin
